"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

require("../style/PublishBanner.css");

var _default = function _default(_ref) {
  var handlePublishOpen = _ref.handlePublishOpen,
      handleRequestOpen = _ref.handleRequestOpen,
      handleInitialClose = _ref.handleInitialClose;
  return _react["default"].createElement(_semanticUiReact.Modal, {
    className: "modal-container initial-modal",
    open: true,
    dimmer: "inverted"
  }, _react["default"].createElement(_semanticUiReact.Modal.Header, null, _react["default"].createElement(_semanticUiReact.Button, {
    id: "inside-close-icon",
    className: "inside-close-icon",
    onClick: handleInitialClose,
    icon: true
  }, _react["default"].createElement(_semanticUiReact.Icon, {
    name: "close"
  }))), _react["default"].createElement(_semanticUiReact.Modal.Content, {
    className: "initial-modal-content"
  }, _react["default"].createElement("h2", null, "Click Publish to make content edits directly, get a free domain, and take your website live."), _react["default"].createElement("br", null), _react["default"].createElement(_semanticUiReact.Button, {
    onClick: handlePublishOpen,
    className: "payment-publish-button"
  }, "Publish"), _react["default"].createElement("br", null), _react["default"].createElement("div", {
    style: {
      marginTop: '1em',
      fontSize: '1.25em'
    }
  }, "Or", ' ', _react["default"].createElement("span", {
    style: {
      textDecoration: 'underline',
      cursor: 'pointer'
    },
    onClick: handleRequestOpen
  }, "request an edit"), ' ', "to your website")));
};

exports["default"] = _default;